import axios from 'axios';

// const BASE_URL = 'http://localhost/taransportmanage/truckmanager/api';
const BASE_URL = 'https://truckmanage.tkambiocapital.com/api';

const client = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000,
});

// Attach JWT token to every request
client.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 globally
client.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = window.location.origin + '/';
    }
    return Promise.reject(err);
  }
);

function extractError(err) {
  return err.response?.data?.message || err.message || 'An unexpected error occurred';
}

// ---- Auth -------------------------------------------------------
export const auth = {
  login: (email, password) => client.post('/auth/login', { email, password }).then(r => r.data.data),
  logout: () => client.post('/auth/logout').then(r => r.data),
  me: () => client.get('/auth/me').then(r => r.data.data),
};

// ---- Trips ------------------------------------------------------
export const trips = {
  list: (params = {}) => client.get('/trips', { params }).then(r => r.data.data),
  get: id => client.get(`/trips/${id}`).then(r => r.data.data),
  create: data => client.post('/trips', data).then(r => r.data.data),
  update: (id, data) => client.put(`/trips/${id}`, data).then(r => r.data.data),
  delete: id => client.delete(`/trips/${id}`).then(r => r.data.data),
  dispatch: id => client.post(`/trips/${id}/dispatch`).then(r => r.data.data),
  start: id => client.post(`/trips/${id}/start`).then(r => r.data.data),
  pause: id => client.post(`/trips/${id}/pause`).then(r => r.data.data),
  resume: id => client.post(`/trips/${id}/resume`).then(r => r.data.data),
  complete: (id, data = {}) => client.post(`/trips/${id}/complete`, data).then(r => r.data.data),
  cancel: (id, reason = '') => client.post(`/trips/${id}/cancel`, { reason }).then(r => r.data.data),
  timeline: id => client.get(`/trips/${id}/timeline`).then(r => r.data.data),
};

// ---- Drivers ----------------------------------------------------
export const drivers = {
  list: (params = {}) => client.get('/drivers', { params }).then(r => r.data.data),
  get: id => client.get(`/drivers/${id}`).then(r => r.data.data),
  create: data => client.post('/drivers', data).then(r => r.data.data),
  update: (id, data) => client.put(`/drivers/${id}`, data).then(r => r.data.data),
  delete: id => client.delete(`/drivers/${id}`).then(r => r.data.data),
  available: () => client.get('/drivers/available').then(r => r.data.data),
};

// ---- Vehicles ---------------------------------------------------
export const vehicles = {
  list: (params = {}) => client.get('/vehicles', { params }).then(r => r.data.data),
  get: id => client.get(`/vehicles/${id}`).then(r => r.data.data),
  create: data => client.post('/vehicles', data).then(r => r.data.data),
  update: (id, data) => client.put(`/vehicles/${id}`, data).then(r => r.data.data),
  delete: id => client.delete(`/vehicles/${id}`).then(r => r.data.data),
  available: () => client.get('/vehicles/available').then(r => r.data.data),
};

// ---- HOS --------------------------------------------------------
export const hos = {
  fleet: () => client.get('/hos/fleet').then(r => r.data.data),
  summary: driverId => client.get(`/hos/${driverId}/summary`).then(r => r.data.data),
  logs: (driverId, date) => client.get(`/hos/${driverId}/logs`, { params: { date } }).then(r => r.data.data),
  createLog: (driverId, data) => client.post(`/hos/${driverId}/logs`, data).then(r => r.data.data),
  violations: driverId => client.get(`/hos/${driverId}/violations`).then(r => r.data.data),
};

// ---- Fuel -------------------------------------------------------
export const fuel = {
  list: (params = {}) => client.get('/fuel', { params }).then(r => r.data.data),
  create: data => client.post('/fuel', data).then(r => r.data.data),
};

// ---- Analytics --------------------------------------------------
export const analytics = {
  kpis: (range = '30d') => client.get('/analytics/kpis', { params: { range } }).then(r => r.data.data),
  fuelEfficiency: (range = '30d') => client.get('/analytics/fuel-efficiency', { params: { range } }).then(r => r.data.data),
  driverPerformance: (range = '30d') => client.get('/analytics/driver-performance', { params: { range } }).then(r => r.data.data),
  tripsByStatus: (range = '30d') => client.get('/analytics/trips-by-status', { params: { range } }).then(r => r.data.data),
};

// ---- Users ------------------------------------------------------
export const users = {
  list: () => client.get('/users').then(r => r.data.data),
  get: id => client.get(`/users/${id}`).then(r => r.data.data),
  create: data => client.post('/users', data).then(r => r.data.data),
  update: (id, data) => client.put(`/users/${id}`, data).then(r => r.data.data),
  delete: id => client.delete(`/users/${id}`).then(r => r.data.data),
};

export { extractError };
export default client;
